import type { ParsedUrlQuery } from 'querystring';

import { adaptPageURLToProductsQueryActiveState } from 'src/adapters/pageURLToStore/adaptPageURLToProductsQueryActiveState';
import { adaptPageURLToStore } from 'src/adapters/pageURLToStore/adaptPageURLToStore';
import { parseUrlFacets } from 'src/adapters/pageURLToStore/parseUrlFacets';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { PageType } from 'src/types/navigation';
import type { SyncProductsQueryFromURLPayload } from '../types/ProductsQueryState';

/**
 * Builds the `syncFromURL` payload from a full URL + current Redux state.
 */
export const getProductsQuerySyncPayloadFromURL = (
  asPath: string,
  query: ParsedUrlQuery,
  state: Pick<ReduxApplicationState, 'navigation' | 'productsQuery'>,
): SyncProductsQueryFromURLPayload => {
  const urlFacets = parseUrlFacets(asPath, state.productsQuery.taxonomyAttributes);

  const activeFacetValuesByKey: Record<string, string[]> = {};
  urlFacets.forEach(({ alias, values }) => {
    activeFacetValuesByKey[alias] = values;
  });

  const processedQuery = adaptPageURLToStore(query);
  const basePayload = adaptPageURLToProductsQueryActiveState(processedQuery, {
    filterPathValues: activeFacetValuesByKey,
    includeSearchTerm: state.navigation.pageType === PageType.Search,
  });

  return basePayload;
};
